import { render, staticRenderFns } from "./Videos.vue?vue&type=template&id=a1c1d370&scoped=true&"
import script from "./Videos.vue?vue&type=script&lang=js&"
export * from "./Videos.vue?vue&type=script&lang=js&"
import style0 from "./Videos.vue?vue&type=style&index=0&id=a1c1d370&prod&lang=scss&scoped=true&"
import style1 from "./Videos.vue?vue&type=style&index=1&id=a1c1d370&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1c1d370",
  null
  
)

export default component.exports